import { isDesktop } from 'react-device-detect';

let scale = isDesktop ? 1 : 2;

export const QuestClaim = {
	name: 'QuestClaim',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'bg',
			type: 'Sprite',
			img: 'quest_reward_item_bg',
			position: { x: 0, y: 0 },
			scale: { x: scale, y: scale }
		},
		{
			name: 'itemimg',
			type: 'Sprite',
			position: { x: 0, y: 0 }
		},
		{
			name: 'itemimgtext',
			type: 'Text',
			position: { x: 0, y: 0 },
			text: 'QUEST_ITEM_CLAIM_IMG_TEXT'
		},
		{
			name: 'itemheader',
			type: 'Text',
			position: { x: 0, y: 0 },
			text: 'QUEST_ITEM_CLAIM_HEADER'
		},
		{
			name: 'itemsubtitle',
			type: 'Text',
			position: { x: 0, y: 0 },
			text: 'QUEST_ITEM_CLAIM_SUBTITLE'
		},
		{
			name: 'switchbtn',
			type: 'SwitchButton',
			position: { x: 16, y: 230 },
			bg: 'quest_activated_btn',
			fg: 'quest_activate_btn',
			bgText: 'QUEST_ACTIVATED_BTN',
			fgText: 'QUEST_ACTIVATE_BTN'
		}
	]
};
